<template>
  <div
    ref="observeElement"
    class="load-more-data" >
    <Spinner
      v-if="!showText"
      class="full-width cover mask-spinner"
      :size="size"
      :thickness="2" />
    <button
      v-else
      :disabled="loading"
      @click="loadMore">
      <span v-if="loading">{{ loadingText }}</span>
      <span v-else>{{ btnText }}</span>
    </button>
  </div>
</template>

<script>
import Spinner from '@/components/common/Spinner';

export default {
  name: 'LoadMoreData',
  components: {
    Spinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 20,
    },
    showText: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: 'Load More',
    },
    loadingText: {
      type: String,
      default: 'Loading...',
    },
  },
  data() {
    return {};
  },
  mounted() {
    const intersectionOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };
    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadMore();
        }
      });
    };
    const observer = new IntersectionObserver(callback, intersectionOptions);
    const target = this.$refs.observeElement;
    observer.observe(target);
  },
  methods: {
    loadMore() {
      this.$emit('loadMore');
    },
  },
};
</script>

<style scoped lang="scss">
.load-more-data {
  display: flex;
  justify-content: center;
  margin: 0;

  button {
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    border: none;
    background-color: #007bff;
    color: white;
    border-radius: 4px;
    transition: background-color 0.3s;

    &:disabled {
      background-color: #6c757d;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background-color: #0056b3;
    }
  }
}
</style>
